import { Checkout } from '@df/checkout/checkout.interfaces';
import { ApplePay } from '@df/module-apple-pay/apple-pay.namespace';

export namespace OpayoApplePay {
    export const METHOD_CODE = 'opayo_applepay';

    export const SCRIPTS = {
        APPLE_PAY: 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
    };

    export const ENDPOINTS = {
        MERCHANT_SESSION_KEY: 'opayoApplepay/merchantsessionkey',
        SESSION: 'opayoApplepay/session',
        TRANSACTION: 'opayoApplepay/transaction'
    };

    export const PAYMENT_CONFIG = {
        COUNTRY_CODE: 'GB',
        CURRENCY_CODE: 'GBP',
        DEFAULT_CURRENCY: 'GBP',
        SESSION_KEY_EXPIRY_SECONDS: 400,
        APPLE_PAY_VERSION: 6
    };

    export const ERROR_MESSAGES = {
        NOT_AVAILABLE: 'Apple Pay is not available. Please select another payment method.',
        INIT_FAILED: 'Failed to initialize Apple Pay',
        SESSION_KEY_FAILED: 'Failed to generate merchant session key',
        MERCHANT_VALIDATION_FAILED: 'Merchant validation failed',
        PAYMENT_FAILED: 'Payment failed',
        PAYMENT_PROCESSING_FAILED: 'Payment processing failed'
    };

    export const DEFAULT_SHIPPING = {
        LABEL: 'Standard Shipping',
        DETAIL: 'Delivery',
        AMOUNT: '5.00',
        IDENTIFIER: 'standard'
    };

    export interface IPaymentMethod extends Checkout.IPaymentMethod {
        config: {
            merchantName: string;
        };
    }

    export interface IApplePayPaymentRequest extends Partial<ApplePay.IPaymentRequest> {
        total: ApplePay.ILineItem;
    }

    export interface IShippingMethodExtended extends Checkout.IShippingMethod {
        carrier_title?: string;
        method_title?: string;
        price_incl_tax?: number;
        carrier_code?: string;
        method_code?: string;
    }

    export interface ICheckoutFormComponentExtended extends Checkout.ICheckoutForPaymentComponent {
        onCheckoutSuccess?(response: unknown): void;
        shippingMethods?: IShippingMethodExtended[];
    }

    export interface IOpayoPaymentResponse {
        success: boolean;
        error?: string;
        transactionId?: string;
        [key: string]: unknown;
    }

    export interface IMerchantSessionKeyResponse {
        success: boolean;
        merchantSessionKey?: string;
        expiry?: string;
        error?: string;
    }

    export interface IApplePaySessionRequest {
        domainName: string;
    }

    export interface IApplePaySessionResponse {
        success: boolean;
        session?: {
            epochTimestamp: string;
            expiresAt: string;
            merchantSessionIdentifier: string;
            nonce: string;
            merchantIdentifier: string;
            domainName: string;
            displayName: string;
            signature: string;
        };
        sessionValidationToken?: string;
        error?: string;
    }

    export interface ITransactionRequest {
        paymentData: unknown;
        merchantSessionKey: string;
        sessionValidationToken?: string;
        applicationData?: string;
        displayName?: string;
    }

    export interface ITransactionResponse {
        success: boolean;
        approved?: boolean;
        transaction_id?: string;
        status?: string;
        response?: {
            statusCode: string;
            status: string;
            transactionId: string;
            [key: string]: unknown;
        };
        error?: string;
    }
}
